import {createContext} from "react";

export const CurrentAgentContext = createContext(null);

